import { Pipe } from '@angular/core';
import { isString, isUndefined } from '../helpers/helpers';
var ScanPipe = (function () {
    function ScanPipe() {
    }
    ScanPipe.prototype.transform = function (text, args) {
        if (args === void 0) { args = []; }
        return isString(text)
            ? text.replace(/\{(\d+)}/g, function (match, index) { return !isUndefined(args[index]) ? args[index] : match; })
            : text;
    };
    return ScanPipe;
}());
export { ScanPipe };
ScanPipe.decorators = [
    { type: Pipe, args: [{ name: 'scan' },] },
];
/** @nocollapse */
ScanPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=scan.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/string/scan.js
// module id = 265
// module chunks = 4